// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"Icons_iconContainer__2_AMu"};